export const BANKSLIP_PAYMENT_ES_MX = {
	// Barcode input step
	infoTitle: "Información",
	barcodeInfo:
		"Se aceptarán hasta 12 boletas de depósito (de pago) con un valor mínimo de R$ 10.00 que se descontarán del saldo disponible.",
	barcodeLabel: "Código de barras",
	barcodePlaceholder: "Ingresa o pega el código de la boleta aquí",
	invalidBarcode: "Código de barras inválido. Verifica e intenta de nuevo.",
	pasteCode: "Pegar código",
	stepBarcode: "Código de barras",
	stepValue: "Valor de la boleta",
	stepReview: "Revisión",

	// Payment amount section (Step 1)
	paymentAmountQuestion: "¿Cuánto quieres pagar?",
	suggestedAmountMessage: "El valor sugerido para esta boleta es de {{amount}}",
	paymentAmountLabel: "Valor de pago",

	// Review step tabs
	tabValues: "Valor de la boleta",
	tabInfo: "Revisión de datos",

	// Review step - Values
	valuesReview: "Revisión de Valores",
	bankSlipValue: "Valor de la boleta",
	anticipationFee: "Multa e intereses",
	discounts: "Descuentos",
	totalToPay: "Valor total a pagar",

	// Review step - Info
	bankSlipInfo: "Información de la Boleta",
	beneficiary: "Beneficiario",
	recipientTaxId: "ID fiscal del beneficiario",
	barCode: "Número del código",
	dueDate: "Vencimiento",
	bank: "Banco",

	// Alerts
	inactiveBankslipTitle: "Boleta inactiva",
	inactiveBankslipMessage:
		"Esta boleta ya fue pagada o hubo un problema en la emisión. Verifica el código e inténtalo de nuevo.",
	expiredBankslipMessage:
		"Esta boleta ha expirado y ya no se puede pagar. Verifica el código e inténtalo de nuevo.",
	missingRecipientTitle: "Datos del receptor no disponibles",
	missingRecipientMessage:
		"No fue posible identificar los datos del beneficiario (nombre e ID fiscal). Verifica la boleta e inténtalo de nuevo.",
	insufficientBalance: "Saldo insuficiente",
	insufficientBalanceDescription: "Saldo disponible insuficiente para realizar el pago.",
	scheduledWarningTitle: "El pago se programará para el próximo día hábil",
	scheduledWarningMessage:
		"Como esta solicitud se realiza después de las 15h, la boleta se pagará el próximo día hábil, ya con el valor actualizado.",

	// Status modal - Success
	successTitle: "¡Todo listo!",
	successDescription:
		"La boleta será enviada para procesamiento por el departamento Financiero.",
	conclude: "Finalizar",
	close: "Cerrar",

	// Status modal - Error
	errorTitle: "No fue posible completar la solicitud",
	errorDescription: "Ocurrió un problema al intentar realizar la solicitud.",
	goBack: "Volver",
	tryAgain: "Intentar de nuevo",

	// Actions
	continue: "Avanzar",
	confirmRequest: "Confirmar solicitud",

	// Loading
	processingPayment: "Procesando pago...",

	// Amount validation
	amountBelowMinimum: "El valor ingresado es menor que el mínimo permitido.",

	// Generic error
	genericError: "Ocurrió un error. Intenta de nuevo.",
};
